import React, { useEffect, useRef, useState } from 'react';
import {
  Wrapper,
  HeaderWrapper,
  Span1,
  Span2,
  ChannelsText,
  TwitterText,
  DateWrapper,
  StyledContainer,
  Container,
  Container2,
  ChildContainer,
  MainComponent,
  SubMainComponent,
  SubComponent1,
  SubComponent2,
  TopicBDiv,
  TopicADiv,
  ButtonDiv,
  ButtonStyle,
  EmotionContainer,
  TabHeading,
  TabWrapper,
  ChildContainerForCustom,
  CancelButtonStyle,
  Color1Span,
  Color2Span,
  LeftChild,
  Divider,
  RightChild,
  DateDiv
} from './ViewCompetitive.styled.js'
import { AmazonIcon, AmazonIconSmall, FacebookIcon, FacebookLogo, FlipkartIcon, FlipkartIconSmall, InstagramLogo, StarIcon, X_LOGO, X_icon, YouTubeRedIcon, download_icon, share_icon, share_icon_white } from '../../Common/SvgIcon/CommonSvgIcons.js';
import Button from '../../Common/Button/Button.jsx';

import Flip from '../../assests/images/flipkart.png';
import Insta from '../../assests/images/Instagram.png';
import CustomAnalysisTab from '../ActiveTopic/CustomAnalysisTab/CustomAnalysisTab.js';
import PercentageBarComp from '../../components/Competitive/PercentageBar.js';
import TrendsMainContainer from './TrendsMainContainer.jsx';
import TopicMentions from './TopicMentions'
import { competitiveIntelligenceReport, competitiveIntelligenceShareReport } from '../../store/redux/slices/competitiveIntelligenceSlice.js';
import { useDispatch, useSelector } from 'react-redux';
import Percentage3BarComp from '../../components/Competitive/Percentage3Bar.js';
import { LoadingWrapper } from '../TopicBuilder/MainContent/QueryBuilder/TopicBuilder.styled.js';
import { CircularProgress } from '@mui/material';
import { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { formatDateFilter } from '../../utils/index.jsx';
import { getPersonalDetails } from '../../store/redux/slices/tenantSettingSlice.js';
import MyDatePicker from '../../components/DatePicker/DatePicker.jsx';
import { shareReport, shareReportCI } from '../../store/redux/slices/sentinelHubSlice.js';
import Lottie from 'lottie-react';
import Loader from '../../assests/animation/Loader2.json';
import CompetitiveHeader from './CompetitiveHeader.jsx';

const ButtonStyles = {
  background: 'white',
  color: 'rgb(45, 137, 85)',
  border: '1px solid rgb(45, 137, 85)',
  fontSize: '14px',
  fontWeight: '400',
  borderRadius: '0px'
}
const Button2Styles = {

  border: '1px solid rgb(45, 137, 85)',
  fontSize: '14px',
  fontWeight: '400',
  borderRadius: '0px'
}


const ViewCompetitive = ({ loading = false, shareReport = false, ci_id, showReportPopup = false, handleCancelClick = () => { console.log("error in report") }, handleGeneratePdf, downloadFeature = false }) => {

  let topicPreviewData = {
    topic_title: 'Competitive Intelligence',
    channel: 'Twitter',
    topicA: {
      title: 'Google Pixel 8',
      startDate: '',
      endDate: ''
    },
    topicB: {
      title: 'Iphone 15',
      startDate: '',
      endDate: ''
    },

  };
  const [isActive, setIsActive] = useState(true);
  const [activeTab, setActiveTab] = useState('overViewTab');
  const [isTopic, setIsTopic] = useState(false)
  const [compData, setCompData] = useState([])
  const [reportType, setReportType] = useState('')

  const [postOption, setPostOption] = useState('Posts');
  const [timeSpan, setTimeSpan] = useState('Days');
  const [timeSpan2, setTimeSpan2] = useState('Days');


  const [analysisData, setAnalysisData] = useState()
  const [loader, setLoader] = useState(false)
  const [shared, setShared] = useState(false)
  const [sameTopic, setSameTopic] = useState(false)

  const { personalDetailsData } = useSelector((state) => state.tenantSetting) || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = window.location.pathname?.split('/')?.[3]?.split('_')?.[1];


  const transformText = (inputText) => {
    // if (inputText == 'twitter') {
    //   return ' ';
    // }
    const words = inputText?.split(' ');
    const transformedWords = words?.map(word => word?.charAt(0).toUpperCase() + word?.slice(1));
    return transformedWords?.join(' ')
  };

  // const { ciPreviewData } = useSelector((state) => state.ciBuilder) || {};
  const { ciPreviewData } = useSelector((state) => state.competitiveIntelligence);

  // const ciPreviewData2 = useSelector((state) => state.ciBuilder.ciPreviewData) || {}
  useEffect(() => {
    setLoader(true)
    if (shareReport) {
      dispatch(competitiveIntelligenceShareReport(ci_id))
        .then((res) => {
          setTimeout(() => {

            setLoader(false)
            setAnalysisData(res?.payload?.data?.report?.ci_analysis || '')
            setCompData(res?.payload?.data?.report?.ci_report || [])
            setReportType(res?.payload?.data?.report_type || '')
            if (res?.payload?.data?.report_type == 'shared') {
              setShared(true)
            } else {
              setShared(false)
            }
            if (res?.payload?.data?.report_type == 'self') {
              setSameTopic(true)
            } else {
              setSameTopic(false)
            }
          }, 1000);
        })
        .catch((err) => {

          setLoader(false)
          setAnalysisData('')
          setCompData([])
          setReportType('')
          setShared(false)
          setSameTopic(false)
        })
    } else if (id) {
      dispatch(competitiveIntelligenceReport(id))
        .then((res) => {

          setTimeout(() => {

            setLoader(false)
            setAnalysisData(res?.payload?.data?.ci_analysis || '')
            setCompData(res?.payload?.data?.ci_report || [])
            setReportType(res?.payload?.data?.report_type || '')
            if (res?.payload?.data?.report_type == 'shared') {
              setShared(true)
            } else {
              setShared(false)
            }
            if (res?.payload?.data?.report_type == 'self') {
              setSameTopic(true)
            } else {
              setSameTopic(false)
            }
          }, 1000);
        })
        .catch((err) => {

          setLoader(false)
          setAnalysisData('')
          setCompData([])
          setReportType('')
          setShared(false)
          setSameTopic(false)
        })
    } else {

      dispatch(competitiveIntelligenceReport(ci_id))
        .then((res) => {

          setTimeout(() => {

            setLoader(false)
            setAnalysisData(res?.payload?.data?.ci_analysis || '')
            setCompData(res?.payload?.data?.ci_report || [])
            setReportType(res?.payload?.data?.report_type || '')
            if (res?.payload?.data?.report_type == 'shared') {
              setShared(true)
            } else {
              setShared(false)
            }
            if (res?.payload?.data?.report_type == 'self') {
              setSameTopic(true)
            } else {
              setSameTopic(false)
            }
          }, 1000);
        })
        .catch((err) => {

          setLoader(false)
          setAnalysisData('')
          setCompData([])
          setReportType('')
          setShared(false)
          setSameTopic(false)
        })

    }

    if (personalDetailsData === null) {
      dispatch(getPersonalDetails());
    }
    setPostOption('Posts')
  }, [id, dispatch]);

  const graphData = [
    {
      "label": 'Male',
      "topicA": compData?.[0]?.ci_report?.gender_demographics?.male_percentage || 0,
      "topicB": compData?.[1]?.ci_report?.gender_demographics?.male_percentage || 0,

    },
    {
      "label": 'Female',
      "topicA": compData?.[0]?.ci_report?.gender_demographics?.female_percentage || 0,
      "topicB": compData?.[1]?.ci_report?.gender_demographics?.female_percentage || 0,
    },
    {
      "label": 'Unknown',
      "topicA": compData?.[0]?.ci_report?.gender_demographics?.unknown_percentage || 0,
      "topicB": compData?.[1]?.ci_report?.gender_demographics?.unknown_percentage || 0,
    },
  ]
  // const graphData = useMemo(() => {
  //   return [{
  //     "label": compData?.[0]?.chatter_topic_title,
  //     "channel": compData?.[0]?.channel,
  //     "male": compData?.[0]?.ci_report?.gender_demographics?.male_percentage,
  //     "female": compData?.[0]?.ci_report?.gender_demographics?.female_percentage,
  //     "unknown": compData?.[0]?.ci_report?.gender_demographics?.unknown_percentage

  //   },
  //   {
  //     "label": compData?.[1]?.chatter_topic_title,
  //     "channel": compData?.[1]?.channel,
  //     "male": compData?.[1]?.ci_report?.gender_demographics?.male_percentage,
  //     "female": compData?.[1]?.ci_report?.gender_demographics?.female_percentage,
  //     "unknown": compData?.[1]?.ci_report?.gender_demographics?.unknown_percentage

  //   }];
  // }, [compData]);

  // const graphDataSentiments = useMemo(() => {
  //   return [{
  //     "label": compData?.[0]?.chatter_topic_title || '',
  //     "channel": compData?.[0]?.channel || '',
  //     "positive": compData?.[0]?.ci_report?.sentiment_metrics?.positive_sentiment || 0,
  //     "negitive": compData?.[0]?.ci_report?.sentiment_metrics?.negative_sentiment || 0,
  //     "neutral": compData?.[0]?.ci_report?.sentiment_metrics?.neutral_sentiment || 0

  //   },
  //   {
  //     "label": compData?.[1]?.chatter_topic_title || '',
  //     "channel": compData?.[1]?.channel || '',
  //     "positive": compData?.[1]?.ci_report?.sentiment_metrics?.positive_sentiment || 0,
  //     "negitive": compData?.[1]?.ci_report?.sentiment_metrics?.negative_sentiment || 0,
  //     "neutral": compData?.[1]?.ci_report?.sentiment_metrics?.neutral_sentiment || 0
  //   }];
  // }, [compData]);
  const graphDataSentiments = [
    {
      "label": 'Positive',
      "topicA": compData?.[0]?.ci_report?.sentiment_metrics?.positive_sentiment || 0,
      "topicB": compData?.[1]?.ci_report?.sentiment_metrics?.positive_sentiment || 0,

    },
    {
      "label": 'Neutral',
      "topicA": compData?.[0]?.ci_report?.sentiment_metrics?.neutral_sentiment || 0,
      "topicB": compData?.[1]?.ci_report?.sentiment_metrics?.neutral_sentiment || 0,
    },
    {
      "label": 'Negative',
      "topicA": compData?.[0]?.ci_report?.sentiment_metrics?.negative_sentiment || 0,
      "topicB": compData?.[1]?.ci_report?.sentiment_metrics?.negative_sentiment || 0,
    },
  ]

  const emotionsData = [
    {
      "label": 'Joy',
      "topicA": compData?.[0]?.ci_report?.emotion?.[0]?.joy || 0,
      "topicB": compData?.[1]?.ci_report?.emotion?.[0]?.joy || 0,

    },
    {
      "label": 'Neutral',
      "topicA": compData?.[0]?.ci_report?.emotion?.[0]?.neutral || 0,
      "topicB": compData?.[1]?.ci_report?.emotion?.[0]?.neutral || 0,
    },

    {
      "label": 'Surprise',
      "topicA": compData?.[0]?.ci_report?.emotion?.[0]?.surprise || 0,
      "topicB": compData?.[1]?.ci_report?.emotion?.[0]?.surprise || 0,
    },
    {
      "label": 'Fear',
      "topicA": compData?.[0]?.ci_report?.emotion?.[0]?.fear || 0,
      "topicB": compData?.[1]?.ci_report?.emotion?.[0]?.fear || 0,
    },
    {
      "label": 'Sadness',
      "topicA": compData?.[0]?.ci_report?.emotion?.[0]?.sadness || 0,
      "topicB": compData?.[1]?.ci_report?.emotion?.[0]?.sadness || 0,
    },

    {
      "label": 'Anger',
      "topicA": compData?.[0]?.ci_report?.emotion?.[0]?.anger || 0,
      "topicB": compData?.[1]?.ci_report?.emotion?.[0]?.anger || 0,
    },

    {
      "label": 'Disgust',
      "topicA": compData?.[0]?.ci_report?.emotion?.[0]?.disgust || 0,
      "topicB": compData?.[1]?.ci_report?.emotion?.[0]?.disgust || 0,
    }

  ];

  const shareComp = () => {
    if (id) {
      dispatch(shareReportCI({
        "ci_id": id,
        "newReportData": {
          ci_analysis: analysisData,
          ci_report: compData
        },
        "render_field_string": {
          trends: timeSpan,
          sentiments: timeSpan2,
          report_type: reportType,
          postOption: postOption,
          report_start_date_1: compData?.[0]?.user_start_date?.replace(/\//g, '-') || '',
          report_end_date: compData?.[0]?.user_end_date?.replace(/\//g, '-') || (compData?.[0]?.end_date && compData?.[0]?.user_end_date == null) ? new Date().toLocaleDateString("en-GB").replace(/\//g, '-') : ''
        },
        "title_name": `${compData?.[0]?.chatter_topic_title} vs ${compData?.[1]?.chatter_topic_title}`,

        "subtitle": `${transformText(compData?.[0]?.channel)} vs ${transformText(compData?.[1]?.channel)}`,

      }))
        .then((res) => {
          // onClose();
        });

    }

  }

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const trendsDataSet = [
    {
      fill: false,
      data: 'topic1_values',
      borderColor: 'rgba(54, 162, 235, 1)', // Line color for topic 1
      pointBackgroundColor: 'green', // Marker color for topic 1
      pointBorderWidth: 0,
      pointRadius: 5, // Size of the markers
    },
    {
      fill: false,
      data: 'topic2_values',
      borderColor: 'rgba(255, 99, 132, 1)', // Line color for topic 1
      pointBackgroundColor: 'red', // Marker color for topic 2

      pointBorderWidth: 0,
      pointRadius: 5, // Size of the markers
      xAxisID: 'topic2_dates', // Use a secondary x-axis for energy
    }
  ];


  const sentimentTrendsDataSet = [
    {
      fill: false,
      data: 'topic1_values',
      borderColor: 'rgba(54, 162, 235, 1)', // Line color for topic 1
      pointBackgroundColor: 'green', // Marker color for topic 1
      pointBorderWidth: 0,
      pointRadius: 5, // Size of the markers
    },
    {
      fill: false,
      data: 'topic2_values',
      borderColor: 'rgba(255, 99, 132, 1)', // Line color for topic 1
      pointBackgroundColor: 'red', // Marker color for topic 2

      borderDash: [10, 5], // Dotted line (10px line, 5px gap)
      pointBorderWidth: 0,
      pointRadius: 5, // Size of the markers
      xAxisID: 'topic2_dates', // Use a secondary x-axis for energy
    }
  ];

  const avgRatingData = [{
    label: 'Average rating',
    topicA: compData?.[0]?.ci_report?.average_rating || 0,
    topicB: compData?.[1]?.ci_report?.average_rating || 0
  }]


  const avgEngagementData = [{
    label: 'Likes',
    topicA: compData?.[0]?.ci_report?.engagement_metrics?.likes || 0,
    topicB: compData?.[1]?.ci_report?.engagement_metrics?.likes || 0
  },
  {
    label: 'Comments',
    topicA: compData?.[0]?.ci_report?.engagement_metrics?.comments || 0,
    topicB: compData?.[1]?.ci_report?.engagement_metrics?.comments || 0
  }
  ]


  const emotionsDataAllValues = emotionsData.flatMap(item => [item.topicA, item.topicB]);

  const emotionsValue = Math.max(...emotionsDataAllValues);
  const emotionMultiplier = 100 / emotionsValue;


  const avgEngageVAlues = avgEngagementData.flatMap(item => [item.topicA, item.topicB]);

  const avgEngageValue = Math.max(...avgEngageVAlues);
  const avgEnagageMultiplier = 100 / avgEngageValue;


  const avgRatingAllVAlues = avgRatingData.flatMap(item => [item.topicA, item.topicB]);

  const avgRatingValue = Math.max(...avgRatingAllVAlues);
  const avgRatingMultiplier = 100 / avgRatingValue;


  const allValues = graphData.flatMap(item => [item.topicA, item.topicB]);
  // const allValues = graphData.flatMap(item => [item.male, item.female, item.unknown]);

  // Find the maximum value among all values
  const maxValue = Math.max(...allValues);
  const multiplier = 100 / maxValue;


  // const allValueSentiments = graphDataSentiments.flatMap(item => [item.positive, item.negitive, item.neutral]);

  const allValueSentiments = graphDataSentiments.flatMap(item => [item.topicA, item.topicB]);
  // Find the maximum value among all values
  const maxValueSentiments = Math.max(...allValueSentiments);
  const multiplierSentiments = 100 / maxValueSentiments;
  // useEffect(() => {
  //   const resizeObserver = new ResizeObserver((entries) => {
  //     const parentWidth = parentRef?.current?.offsetWidth ;
  //     setNumericWidth(parentWidth);
  //   });

  //   resizeObserver.observe(parentRef?.current);

  //   return () => resizeObserver.disconnect();
  // }, []);


  const renderTabContent = () => {
    switch (activeTab) {
      case 'overViewTab':
        return (
          <div style={{ marginBottom: '50px' }}>
            <Container color={downloadFeature}>
              <ChildContainer style={{ minHeight: '350px' }}>
                <TopicMentions
                  shared={sameTopic}
                  data={compData}
                  iconA={
                    compData?.[0]?.channel === "twitter" ? X_icon :
                      compData?.[0]?.channel === "instagram" ? 
                      <> <img src={Insta} style={{ width: '30px' }} /></> :
                        compData?.[0]?.channel == "facebook" ? FacebookLogo :
                        compData?.[0]?.channel === "youtube" ? YouTubeRedIcon :
                          compData?.[0]?.channel === "amazon" ? AmazonIconSmall :
                            compData?.[0]?.channel === "flipkart" ?
                              <> <img src={Flip} style={{ width: '30px' }} /></> :
                              ''
                  }
                  iconB={
                    compData?.[1]?.channel === "twitter" ? X_icon :
                      compData?.[1]?.channel === "instagram" ? 
                      <> <img src={Insta} style={{ width: '30px' }} /></> :
                        compData?.[1]?.channel == "facebook" ? FacebookLogo :
                        compData?.[0]?.channel === "youtube" ? YouTubeRedIcon :
                          compData?.[1]?.channel === "amazon" ? AmazonIconSmall :
                            compData?.[1]?.channel === "flipkart" ?
                              <> <img src={Flip} style={{ width: '30px' }} /></> :
                              ''
                  }
                />
              </ChildContainer>

              {/* <Percentage3BarComp
                analysisData={analysisData}
                compData={compData}
                title={'Gender Demographics'}
                data={graphData}
                multiplier={multiplier}
                summary1={analysisData?.gender_demographics?.data_1 || ''}
                summary2={analysisData?.gender_demographics?.data_2 || ''}
              /> */}
              <PercentageBarComp
                analysisData={analysisData}
                title={'Gender Demographics'}
                data={graphData}
                multiplier={multiplier}
                compData={compData}
                summary1={analysisData?.gender_demographics?.data_1 || ''}
                summary2={analysisData?.gender_demographics?.data_2 || ''}
              />


            </Container>

            <div style={{
              padding: '30px 3px 0px 30px',
              width: '30%',

              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center'
            }}>
              <Button
                value={'User Activity'}
                style={!isActive ? ButtonStyles : Button2Styles}
                onClick={() => setIsActive(true)}
              />
              <Button
                value={'Sentiment Trends'}
                style={isActive ? ButtonStyles : Button2Styles}
                onClick={() => setIsActive(false)}
              />
            </div>
            {
              isActive ?

                <Container2>
                  <TrendsMainContainer
                    postOption={postOption}
                    setPostOption={setPostOption}
                    timeSpan={timeSpan}
                    setTimeSpan={setTimeSpan}
                    shared={shared}
                    downloadFeature={downloadFeature}
                    compData={compData}
                    showGraphLabel={false}
                    trendsDataSet={trendsDataSet}
                    analysisData={analysisData}
                    summary1={analysisData?.trends?.data_1}
                    summary2={analysisData?.trends?.data_2}
                    showsummary={true}
                  />
                </Container2>
                :

                <Container2>

                  <TrendsMainContainer
                    postOption={postOption}
                    setPostOption={setPostOption}
                    timeSpan={timeSpan2}
                    setTimeSpan={setTimeSpan2}
                    shared={shared}
                    downloadFeature={downloadFeature}
                    compData={compData}
                    showGraphLabel={true}
                    trendsDataSet={sentimentTrendsDataSet}
                    analysisData={analysisData}
                    summary1={analysisData?.sentiment_trends}
                    summary2={''}
                    showsummary={false}
                    showFilter={!shareReport}
                  />

                </Container2>
            }
            {
              // isActive &&

              <Container>
                {
                  compData?.[0]?.channel === 'amazon' || compData?.[0]?.channel === 'flipkart' ?
                    <PercentageBarComp
                      analysisData={analysisData}
                      title={'Average Rating'}
                      data={avgRatingData}
                      multiplier={avgRatingMultiplier}
                      compData={compData}
                      summary1={analysisData?.rating_engagement_metrics?.average_rating || ''}
                    // summary2={analysisData?.gender_demographics?.data_2 || ''}
                    />

                    :
                    <PercentageBarComp
                      analysisData={analysisData}
                      title={'Engagement Metrics'}
                      data={avgEngagementData}
                      multiplier={avgEnagageMultiplier}
                      compData={compData}

                      summary1={analysisData?.rating_engagement_metrics?.likes || ''}
                      summary2={analysisData?.rating_engagement_metrics?.comments || ''}
                    />

                }
                <PercentageBarComp
                  analysisData={analysisData}
                  title={'Sentiments'}
                  data={graphDataSentiments}
                  multiplier={multiplierSentiments}
                  compData={compData}

                  summary1={analysisData?.rating_engagement_metrics?.likes || ''}
                  summary2={analysisData?.rating_engagement_metrics?.comments || ''}
                />
                {/* <Percentage3BarComp
                  analysisData={analysisData}
                  compData={compData}
                  title={'Sentiments'}
                  data={graphDataSentiments}
                  showSentiment={true}
                  multiplier={multiplierSentiments}

                  summary1={''}
                  summary2={''}
                /> */}


              </Container>


            }

            {

              // isActive &&
              <EmotionContainer>

                <PercentageBarComp
                  title={'Emotions'}
                  data={emotionsData}
                  multiplier={emotionMultiplier}
                  compData={compData}

                  summary1={analysisData?.emotion?.data_1 || ''}
                  summary2={analysisData?.emotion?.data_2 || ''}
                />


              </EmotionContainer>

            }


          </div>
        );

      case 'CustomQuery':
        return (
          <div>
            <Container>

              <ChildContainerForCustom>
                <CustomAnalysisTab
                // job_id={job_id}
                // preview_uuid={topicPreviewData?.preview_uuid}
                // onUpdateSearchQuery={updateSearchQuery}
                // channel={topicPreviewData?.channel}
                />
              </ChildContainerForCustom>
            </Container>


          </div>);
    };

  };


  const formatValue = personalDetailsData?.app_preference?.date_format === "dd/mm/yyyy" ? 'dd-MM-yyyy' :
    personalDetailsData?.app_preference?.date_format === "mm/dd/yyyy" ? 'MM-dd-yyyy' :
      personalDetailsData?.app_preference?.date_format === "yyyy/mm/dd" ? 'yyyy-MM-dd' :
        'dd-MM-yyyy';

  return (
    <Wrapper color={downloadFeature}>
      {
        loader &&
        <LoadingWrapper>
          <div data-testid='loader'>
            <Lottie
              data-testid='loader'
              animationData={Loader}
              loop={true}
              width='100px'
              height='100px'
            />
            {/* <CircularProgress /> */}
          </div>
        </LoadingWrapper>
      }
      {!downloadFeature && !shareReport && (
        <button
          onClick={() => navigate('/competitiveIntelligence/home')}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '15px',
            fontWeight: '500',
            color: '#000',
            padding: '8px 0 8px 25px',
            borderRadius: '6px',
            marginBottom: '-12px',
          }}
        >
          ← Back
        </button>
      )}
      <HeaderWrapper>
        <MainComponent shared={shared}>
          <CompetitiveHeader compData={compData} shared={shared} />
          {shared && <DateDiv style={{ alignItems: 'center' }}>
            <div className='label'>Start Date :</div>
            <div>{compData?.[0]?.user_start_date?.replace(/\//g, '-') || ''}</div>

            <div className='label'>End Date :</div>
            <div>{compData?.[0]?.user_end_date ? compData?.[0]?.user_end_date.replace(/\//g, '-') : compData?.[0]?.end_date ? compData?.[0]?.end_date.replace(/\//g, '-') : ''}</div>           
          </DateDiv>}
        </MainComponent>
      </HeaderWrapper>
      <Wrapper >
        <TabWrapper>
          <div></div>
          {/* <TabHeading> */}
            {/* <div
              className={activeTab === 'overViewTab' ? 'activePlanTab' : ''}
              onClick={() => handleTabClick('overViewTab')}
            >
              Overviews
            </div> */}
            {/* <div
              className={activeTab === 'CustomQuery' ? 'activePlanTab' : ''}
              onClick={() => handleTabClick('CustomQuery')}
            >
              Custom Queries
            </div> */}

          {/* </TabHeading> */}
          {
            showReportPopup ?

              <ButtonDiv style={{ paddingRight: '0px' }}>

                <CancelButtonStyle style={{ marginRight: '15px' }} onClick={handleCancelClick}>
                  Cancel
                </CancelButtonStyle>
                {
                  loading ?
                    <ButtonStyle >{`...Downloading`}</ButtonStyle>

                    :
                    <ButtonStyle onClick={() => handleGeneratePdf()}> Download {download_icon}</ButtonStyle>

                }

              </ButtonDiv>
              :

              <ButtonDiv >
                <ButtonStyle onClick={() => shareComp()}>Share {share_icon_white}</ButtonStyle>

              </ButtonDiv>
          }

        </TabWrapper>

        {renderTabContent()}

      </Wrapper>


    </Wrapper>
  );
};


export default ViewCompetitive;